import React from "react";
import ErrorPage from "./ErrorPage";

export default function Error500(props) {
  return <ErrorPage code={500} {...props} />;
}
